import axiosInstance from "./service-instance";
import {
    CONTENT_TYPES
    // CASE_TYPES
} from "constants";

export default {
    createFinancialYear: (company_id, name) =>
        axiosInstance.post(
            "/master/financial-year/list/",
            {
                name
            },
            {
                headers: {
                    "Content-Type": CONTENT_TYPES.APPLICATION_JSON
                }
            }
        ),
    fetchFinancialYears: () =>
        axiosInstance.get("/master/financial-year/list/", {
            params: {
                paginate: false
            }
        }),
    fetchFinancials: companyId =>
        axiosInstance.get(`/company/${companyId}/financial-detail/`),
    updateFinancials: (companyId, records) =>
        axiosInstance.post(`/company/${companyId}/financial-detail/`, records, {
            headers: {
                "Content-Type": CONTENT_TYPES.APPLICATION_JSON
            }
        })
};
